import React from 'react';

import { ProductRowPlaceholder } from '../ProductPodPlaceholders/ProductRowPlaceholder';
import { useSpecialBuy } from '../../context/SpecialBuyProvider';
import { CategoryProducts } from '../CategoryProducts/CategoryProducts';

const SpecialBuyCarousel = () => {
  const { categories } = useSpecialBuy();

  return (
    <section>
      {!categories.length ? (
        <ProductRowPlaceholder />
      ) : (
        <>
          {categories.map((category) => (
            <CategoryProducts
              key={category.categoryId}
              category={category}
            />
          ))}
        </>
      )}
    </section>
  );
};

SpecialBuyCarousel.displayName = 'SpecialBuyCarousel';

export { SpecialBuyCarousel };
